import { useRef, useEffect } from 'react';
// @mui
import {
  Badge,
  IconButton,
} from '@mui/material';
// utils
// components
import NotificationsIcon from '@mui/icons-material/Notifications';
// react-router-dom
import { useNavigate, useLocation } from 'react-router-dom';
// @ts-ignore: Cannot find module './not-a-module'
import NOTIFICATION_SOUND from '../../../assets/sounds/notification_sound.mp3';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { resetNotification, closeNotificationSound, openNotificationSound } from '../../../store/notificationSlice';
import { ORDER_ROUTE } from '../../../routes/paths';

import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeDownIcon from '@mui/icons-material/VolumeDown';
// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const notification = useSelector((state: RootState) => state?.notificationSlice);

  const videoEl = useRef<any>(null);

  const onClick = () => {
    if (pathname !== ORDER_ROUTE) {
      navigate(ORDER_ROUTE);
    }
    dispatch(resetNotification());
  }

  const handleTriggerNotification = () => {
    videoEl.current.currentTime = 0;
    videoEl.current.play();
  }

  useEffect(() => {
    if (notification.ringing === true) {
      handleTriggerNotification();
    }
    else {
      videoEl.current.pause();
    }
  }, [notification])



  const toggleNotificationSound = () => {
    if (notification.sound) {
      dispatch(closeNotificationSound());
    } else {
      dispatch(openNotificationSound());
    }
  };


  return (
    <>
      <IconButton onClick={toggleNotificationSound}>
        {
          notification.sound === false
            ?
            <VolumeOffIcon />
            :
            <VolumeDownIcon htmlColor='green' />
        }
      </IconButton>
      <IconButton onClick={onClick} sx={{ width: 40, height: 40 }}>
        <Badge badgeContent={notification?.count} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <video
        style={{ display: 'none' }}
        playsInline
        loop
        muted={!notification.sound}
        controls
        src={NOTIFICATION_SOUND}
        ref={videoEl}
      />
    </>
  );
}
